import { render, staticRenderFns } from "./ProductComments.vue?vue&type=template&id=e50a9aac&scoped=true&"
import script from "./ProductComments.vue?vue&type=script&lang=js&"
export * from "./ProductComments.vue?vue&type=script&lang=js&"
import style0 from "./ProductComments.vue?vue&type=style&index=0&id=e50a9aac&scoped=true&lang=css&"
import style1 from "./ProductComments.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e50a9aac",
  null
  
)

export default component.exports